import {
  usePpraSurveyControllerGetLatestResults,
  usePpraSurveyControllerGetPpraResults,
} from '@/api/generated/ppra/ppra';
import useOnMount from '@/hooks/useOnMount';
import useVisitorSession from '@/hooks/useVisitorSession';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export default function usePpraResultsController() {
  const { surveySessionId } = useParams<{ surveySessionId: string }>();
  const isPDP = !surveySessionId || surveySessionId.trim().toLowerCase() === 'pdp';
  const { sessionToken, initializeSession } = useVisitorSession();
  const sessionTokenReady = sessionToken !== null;

  useOnMount(() => {
    if (!sessionTokenReady) {
      initializeSession();
    }
  });

  const { data: resultsData, error: resultsError } = usePpraSurveyControllerGetPpraResults(surveySessionId || '', {
    query: {
      enabled: !!surveySessionId && !isPDP && sessionTokenReady,
      staleTime: Infinity,
    },
  });

  const { data: latestResultsData, error: latestResultsError } = usePpraSurveyControllerGetLatestResults({
    query: {
      enabled: sessionTokenReady && isPDP,
      staleTime: Infinity,
      retry: false,
    },
  });

  // Error handling
  useEffect(() => {
    if (resultsError) {
      console.error('Error retrieving assessment results:', resultsError);
    }
  }, [resultsError]);

  return {
    results: resultsData?.results || latestResultsData?.results,
    error: resultsError || latestResultsError,
  };
}
